import {Navigate, useLocation} from "react-router-dom";
import React from "react";

export const RequireBasicAuth = ( { children }: { children: React.ReactNode } )=> {
  const location = useLocation();
  const isAuthenticated = (localStorage.getItem("isAuthenticated") === "true");
  return isAuthenticated ? children as React.ReactElement : <Navigate to={'/login'} state={{ from: location }} replace/>;
}